export const navigationData = {
  items: [
    {
      title: "Destinations",
      url: "https://www.lonelyplanet.com/places",
      cta: {
        title: "view all destinations",
        url: "https://www.lonelyplanet.com/places",
      },
      featured: {
        title: "Not sure where to start?",
        description:
          "Get inspired by destinations chosen in this year's Best in Travel list.",
        image:
          "https://lonelyplanetstatic.imgix.net/marketing/2025/global_nav/nav_bit.jpg",
        cta: {
          title: "Start Discovering",
          url: "https://www.lonelyplanet.com/best-in-travel",
        },
      },
      submenu: {
        items: [
          {
            title: "Trending",
            items: [
              {
                title: "Athens",
                url: "https://www.lonelyplanet.com/destinations/greece/athens",
                image:
                  "https://lp-cms-production.imgix.net/2020-11/GettyRF_663376932.jpg",
              },
              {
                title: "Malta",
                url: "https://www.lonelyplanet.com/destinations/malta",
                image:
                  "https://lp-cms-production.imgix.net/2022-11/Malta-iStock-1296277157-RFE.jpeg",
              },
              {
                title: "Puerto Rico",
                url: "https://www.lonelyplanet.com/destinations/puerto-rico",
                image:
                  "https://lp-cms-production.imgix.net/2025-04/shutterstockRF234381985.jpg",
              },
              {
                title: "Cancun",
                url: "https://www.lonelyplanet.com/destinations/mexico/cancun",
                image:
                  "https://lp-cms-production.imgix.net/2022-12/Mexico-iStock-484404659-RFC.jpeg",
              },
              {
                title: "Miami",
                url: "https://www.lonelyplanet.com/destinations/usa/miami",
                image:
                  "https://lp-cms-production.imgix.net/2020-11/GettyRF_888220956.jpg",
              },
              {
                title: "Yellowstone",
                url: "https://www.lonelyplanet.com/destinations/usa/rocky-mountains/yellowstone-national-park",
                image:
                  "https://lp-cms-production.imgix.net/2025-04/shutterstock287588156.jpg",
              },
            ],
          },
          {
            title: "Countries",
            items: [
              {
                columns: [
                  {
                    title: "Europe",
                    items: [
                      {
                        title: "Croatia",
                        url: "https://www.lonelyplanet.com/destinations/croatia",
                      },
                      {
                        title: "France",
                        url: "https://www.lonelyplanet.com/destinations/france",
                      },
                      {
                        title: "Greece",
                        url: "https://www.lonelyplanet.com/destinations/greece",
                      },
                      {
                        title: "Iceland ",
                        url: "https://www.lonelyplanet.com/destinations/iceland",
                      },
                      {
                        title: "Italy",
                        url: "https://www.lonelyplanet.com/destinations/italy",
                      },
                      {
                        title: "Portugal",
                        url: "https://www.lonelyplanet.com/destinations/portugal",
                      },
                      {
                        title: "Spain",
                        url: "https://www.lonelyplanet.com/destinations/spain",
                      },
                    ],
                  },
                  {
                    title: "The Americas",
                    items: [
                      {
                        title: "Canada",
                        url: "https://www.lonelyplanet.com/destinations/canada",
                      },
                      {
                        title: "Costa Rica",
                        url: "https://www.lonelyplanet.com/destinations/costa-rica",
                      },
                      {
                        title: "Mexico",
                        url: "https://www.lonelyplanet.com/destinations/mexico",
                      },
                      {
                        title: "Peru",
                        url: "https://www.lonelyplanet.com/destinations/peru",
                      },
                      {
                        title: "United States",
                        url: "https://www.lonelyplanet.com/destinations/usa",
                      },
                    ],
                  },
                  {
                    title: "More",
                    items: [
                      {
                        title: "Australia",
                        url: "https://www.lonelyplanet.com/destinations/australia",
                      },
                      {
                        title: "Japan",
                        url: "https://www.lonelyplanet.com/destinations/japan",
                      },
                      {
                        title: "Morocco",
                        url: "https://www.lonelyplanet.com/destinations/morocco",
                      },
                      {
                        title: "Sri Lanka",
                        url: "https://www.lonelyplanet.com/destinations/sri-lanka",
                      },
                      {
                        title: "Thailand",
                        url: "https://www.lonelyplanet.com/destinations/thailand",
                      },
                      {
                        title: "Turkey  ",
                        url: "https://www.lonelyplanet.com/destinations/turkey",
                      },
                      {
                        title: "Vietnam",
                        url: "https://www.lonelyplanet.com/destinations/vietnam",
                      },
                    ],
                  },
                ],
              },
            ],
          },
          {
            title: "Regions",
            items: [
              {
                columns: [
                  {
                    title: "Europe",
                    items: [
                      {
                        title: "Amalfi Coast",
                        url: "https://www.lonelyplanet.com/destinations/italy/amalfi-coast",
                      },
                      {
                        title: "Azores",
                        url: "https://www.lonelyplanet.com/destinations/portugal/the-azores-1341351",
                      },
                      {
                        title: "Cinque Terre",
                        url: "https://www.lonelyplanet.com/destinations/italy/cinque-terre",
                      },
                      {
                        title: "Puglia",
                        url: "https://www.lonelyplanet.com/destinations/italy/puglia",
                      },
                      {
                        title: "Sardinia",
                        url: "https://www.lonelyplanet.com/destinations/italy/sardinia",
                      },
                      {
                        title: "Sicily",
                        url: "https://www.lonelyplanet.com/destinations/italy/sicily",
                      },
                      {
                        title: "Tuscany",
                        url: "https://www.lonelyplanet.com/destinations/italy/tuscany",
                      },
                    ],
                  },
                  {
                    title: "The Americas",
                    items: [
                      {
                        title: "Alaska  ",
                        url: "https://www.lonelyplanet.com/destinations/usa/alaska",
                      },
                      {
                        title: "California",
                        url: "https://www.lonelyplanet.com/destinations/usa/california",
                      },
                      {
                        title: "Colorado",
                        url: "https://www.lonelyplanet.com/destinations/usa/rocky-mountains/colorado",
                      },
                      {
                        title: "Florida",
                        url: "https://www.lonelyplanet.com/destinations/usa/florida",
                      },
                      {
                        title: "Hawaii",
                        url: "https://www.lonelyplanet.com/destinations/usa/hawaii",
                      },
                      {
                        title: "Patagonia",
                        url: "https://www.lonelyplanet.com/destinations/argentina/patagonia",
                      },
                      {
                        title: "Texas",
                        url: "https://www.lonelyplanet.com/destinations/usa/texas",
                      },
                    ],
                  },
                  {
                    title: "More",
                    items: [
                      {
                        title: "Bali",
                        url: "https://www.lonelyplanet.com/destinations/indonesia/bali",
                      },
                      {
                        title: "Phuket",
                        url: "https://www.lonelyplanet.com/destinations/thailand/phuket-province",
                      },
                      {
                        title: "Southeast Asia",
                        url: "https://www.lonelyplanet.com/destinations/southeast-asia",
                      },
                    ],
                  },
                ],
              },
            ],
          },
          {
            title: "Cities",
            items: [
              {
                columns: [
                  {
                    title: "Europe",
                    items: [
                      {
                        title: "Barcelona",
                        url: "https://www.lonelyplanet.com/destinations/spain/barcelona",
                      },
                      {
                        title: "London",
                        url: "https://www.lonelyplanet.com/destinations/england/london",
                      },
                      {
                        title: "Madrid",
                        url: "https://www.lonelyplanet.com/destinations/spain/madrid",
                      },
                      {
                        title: "Paris",
                        url: "https://www.lonelyplanet.com/destinations/france/paris",
                      },
                      {
                        title: "Porto",
                        url: "https://www.lonelyplanet.com/destinations/portugal/the-north/porto",
                      },
                      {
                        title: "Rome",
                        url: "https://www.lonelyplanet.com/destinations/italy/rome",
                      },
                      {
                        title: "Santorini",
                        url: "https://www.lonelyplanet.com/destinations/greece/cyclades/santorini-thira",
                      },
                    ],
                  },
                  {
                    title: "The Americas",
                    items: [
                      {
                        title: "Buenos Aires",
                        url: "https://www.lonelyplanet.com/destinations/argentina/buenos-aires",
                      },
                      {
                        title: "Lima",
                        url: "https://www.lonelyplanet.com/destinations/peru/lima",
                      },
                      {
                        title: "Los Angeles",
                        url: "https://www.lonelyplanet.com/destinations/usa/los-angeles",
                      },
                      {
                        title: "Mexico City",
                        url: "https://www.lonelyplanet.com/destinations/mexico/mexico-city",
                      },
                      {
                        title: "New Orleans",
                        url: "https://www.lonelyplanet.com/destinations/usa/new-orleans",
                      },
                      {
                        title: "New York City",
                        url: "https://www.lonelyplanet.com/destinations/usa/new-york-city",
                      },
                      {
                        title: "San Francisco",
                        url: "https://www.lonelyplanet.com/destinations/usa/san-francisco",
                      },
                    ],
                  },
                  {
                    title: "More",
                    items: [
                      {
                        title: "Bangkok",
                        url: "https://www.lonelyplanet.com/destinations/thailand/bangkok",
                      },
                      {
                        title: "Chiang Mai",
                        url: "https://www.lonelyplanet.com/destinations/thailand/chiang-mai-province/chiang-mai",
                      },
                      {
                        title: "Ho Chi Minh City",
                        url: "https://www.lonelyplanet.com/destinations/vietnam/ho-chi-minh-city",
                      },
                      {
                        title: "Istanbul",
                        url: "https://www.lonelyplanet.com/destinations/turkey/istanbul",
                      },
                      {
                        title: "Kyoto",
                        url: "https://www.lonelyplanet.com/destinations/japan/kansai/kyoto",
                      },
                      {
                        title: "Marrakesh",
                        url: "https://www.lonelyplanet.com/destinations/morocco/marrakesh",
                      },
                      {
                        title: "Tokyo",
                        url: "https://www.lonelyplanet.com/destinations/japan/tokyo",
                      },
                    ],
                  },
                ],
              },
            ],
          },
          {
            title: "Continents",
            items: [
              {
                title: "Africa",
                url: "https://www.lonelyplanet.com/destinations/africa",
              },
              {
                title: "Antarctica",
                url: "https://www.lonelyplanet.com/destinations/antarctica",
              },
              {
                title: "Asia",
                url: "https://www.lonelyplanet.com/destinations/asia",
              },
              {
                title: "Australia & The Pacific",
                url: "https://www.lonelyplanet.com/destinations/pacific",
              },
              {
                title: "The Caribbean",
                url: "https://www.lonelyplanet.com/destinations/caribbean",
              },
              {
                title: "Central America",
                url: "https://www.lonelyplanet.com/destinations/central-america",
              },
              {
                title: "Europe",
                url: "https://www.lonelyplanet.com/destinations/europe",
              },
              {
                title: "Middle East",
                url: "https://www.lonelyplanet.com/destinations/middle-east",
              },
              {
                title: "North America",
                url: "https://www.lonelyplanet.com/destinations/north-america",
              },
              {
                title: "South America",
                url: "https://www.lonelyplanet.com/destinations/south-america",
              },
            ],
          },
        ],
      },
    },
    {
      title: "Books",
      url: "https://shop.lonelyplanet.com/?utm_source=lonelyplanet&utm_campaign=navigation&utm_content=homepage",
      cta: {
        title: "view all books",
        url: "https://shop.lonelyplanet.com/?utm_source=lonelyplanet&utm_campaign=navigation&utm_content=homepage",
      },
      featured: {
        title: "Italy's Newest Addition",
        description:
          "Explore Italy's iconic landmarks and hidden gems with expert insights in Lonely Planet's latest Italy guide.",
        image:
          "https://lonelyplanetstatic.imgix.net/marketing/2025/global_nav/gifts_new_releases_italy_book_4X.jpg",
        cta: {
          title: "shop the newest release",
          url: "https://shop.lonelyplanet.com/products/italy?utm_source=lonelyplanet&utm_campaign=navigation&utm_content=shopnewrelease",
        },
        tracking: {
          event: "ProductClicked",
          product: { brand: "Shop" },
        },
      },
      submenu: {
        items: [
          {
            title: "Destination Guides",
            items: [
              {
                columns: [
                  {
                    title: "Europe",
                    items: [
                      {
                        title: "Croatia",
                        url: "http://shop.lonelyplanet.com/collections/croatia?utm_source=lonelyplanet&utm_campaign=navigation&utm_content=destinationguides-croatia",
                      },
                      {
                        title: "Europe",
                        url: "http://shop.lonelyplanet.com/collections/europe?utm_source=lonelyplanet&utm_campaign=navigation&utm_content=destinationguides-europe",
                      },
                      {
                        title: "Greece",
                        url: "http://shop.lonelyplanet.com/collections/greece?utm_source=lonelyplanet&utm_campaign=navigation&utm_content=destinationguides-greece",
                      },
                      {
                        title: "Ireland",
                        url: "http://shop.lonelyplanet.com/collections/ireland?utm_source=lonelyplanet&utm_campaign=navigation&utm_content=destinationguides-ireland",
                      },
                      {
                        title: "Italy",
                        url: "http://shop.lonelyplanet.com/collections/italy?utm_source=lonelyplanet&utm_campaign=navigation&utm_content=destinationguides-italy",
                      },
                      {
                        title: "Portugal",
                        url: "http://shop.lonelyplanet.com/collections/portugal?utm_source=lonelyplanet&utm_campaign=navigation&utm_content=destinationguides-portugal",
                      },
                      {
                        title: "Spain",
                        url: "http://shop.lonelyplanet.com/collections/spain?utm_source=lonelyplanet&utm_campaign=navigation&utm_content=destinationguides-spain",
                      },
                    ],
                  },
                  {
                    title: "The Americas",
                    items: [
                      {
                        title: "Canada",
                        url: "https://shop.lonelyplanet.com/collections/canada?utm_source=lonelyplanet&utm_campaign=navigation&utm_content=destinationguides-canada",
                      },
                      {
                        title: "Central America",
                        url: "https://shop.lonelyplanet.com/collections/all-central-america-guides?sort_by=title-ascending?utm_source=lonelyplanet&utm_campaign=navigation&utm_content=destinationguides-centralamerica",
                      },
                      {
                        title: "Mexico",
                        url: "http://shop.lonelyplanet.com/collections/mexico?utm_source=lonelyplanet&utm_campaign=navigation&utm_content=destinationguides-mexico",
                      },
                      {
                        title: "North America",
                        url: "http://shop.lonelyplanet.com/collections/north-america?utm_source=lonelyplanet&utm_campaign=navigation&utm_content=destinationguides-northamerica",
                      },
                      {
                        title: "Peru",
                        url: "https://shop.lonelyplanet.com/collections/peru?utm_source=lonelyplanet&utm_campaign=navigation&utm_content=destinationguides-peru",
                      },
                      {
                        title: "South America",
                        url: "http://shop.lonelyplanet.com/collections/south-america?utm_source=lonelyplanet&utm_campaign=navigation&utm_content=destinationguides-southamerica",
                      },
                      {
                        title: "United States",
                        url: "http://shop.lonelyplanet.com/collections/usa?utm_source=lonelyplanet&utm_campaign=navigation&utm_content=destinationguides-us",
                      },
                    ],
                  },
                  {
                    title: "More",
                    items: [
                      {
                        title: "Africa",
                        url: "http://shop.lonelyplanet.com/collections/africa?utm_source=lonelyplanet&utm_campaign=navigation&utm_content=destinationguides-africa",
                      },
                      {
                        title: "Asia",
                        url: "http://shop.lonelyplanet.com/collections/asia?utm_source=lonelyplanet&utm_campaign=navigation&utm_content=destinationguides-asia",
                      },
                      {
                        title: "Australia",
                        url: "http://shop.lonelyplanet.com/collections/australia?utm_source=lonelyplanet&utm_campaign=navigation&utm_content=destinationguides-australia",
                      },
                      {
                        title: "India",
                        url: "http://shop.lonelyplanet.com/collections/india?utm_source=lonelyplanet&utm_campaign=navigation&utm_content=destinationguides-india",
                      },
                      {
                        title: "Japan",
                        url: "http://shop.lonelyplanet.com/collections/japan?utm_source=lonelyplanet&utm_campaign=navigation&utm_content=destinationguides-japan",
                      },
                      {
                        title: "Thailand",
                        url: "http://shop.lonelyplanet.com/collections/thailand?utm_source=lonelyplanet&utm_campaign=navigation&utm_content=destinationguides-thailand",
                      },
                      {
                        title: "Vietnam",
                        url: "http://shop.lonelyplanet.com/collections/vietnam?utm_source=lonelyplanet&utm_campaign=navigation&utm_content=destinationguides-vietnam",
                      },
                    ],
                  },
                ],
              },
            ],
          },
          {
            title: "Trending Guides",
            items: [
              {
                title: "Bali",
                url: "https://shop.lonelyplanet.com/collections/bali?utm_source=lonelyplanet&utm_campaign=navigation&utm_content=trending-bali",
                image:
                  "https://lp-cms-production.imgix.net/2025-04/shutterstock2574309095.jpg",
              },
              {
                title: "Indonesia",
                url: "https://shop.lonelyplanet.com/collections/indonesia?utm_source=lonelyplanet&utm_campaign=navigation&utm_content=trending-indonesia",
                image:
                  "https://lp-cms-production.imgix.net/2025-04/Shutterstock1124482919.jpg",
              },
              {
                title: "Korea",
                url: "https://shop.lonelyplanet.com/collections/south-korea?utm_source=lonelyplanet&utm_campaign=navigation&utm_content=trending-korea",
                image:
                  "https://lp-cms-production.imgix.net/2025-04/shutterstock1874286289.jpg",
              },
              {
                title: "Germany",
                url: "https://shop.lonelyplanet.com/collections/germany?utm_source=lonelyplanet&utm_campaign=navigation&utm_content=trending-germany",
                image:
                  "https://lp-cms-production.imgix.net/2025-04/Shutterstock1502282249.jpg",
              },
              {
                title: "Sicily",
                url: "https://shop.lonelyplanet.com/products/sicily?utm_source=lonelyplanet&utm_campaign=navigation&utm_content=trending-sicily",
                image:
                  "https://lp-cms-production.imgix.net/2024-02/Italy-Sicily-Favignana-Maremagnum-GettyImages-595333295-RF.jpg",
                tracking: {
                  event: "ProductClicked",
                  product: { brand: "Shop" },
                },
              },
              {
                title: "Western Balkans",
                url: "https://shop.lonelyplanet.com/products/western-balkans?utm_source=lonelyplanet&utm_campaign=navigation&utm_content=trending-westernbalkans",
                image:
                  "https://lp-cms-production.imgix.net/2024-01/LPT1018028.jpg",
                tracking: {
                  event: "ProductClicked",
                  product: { brand: "Shop" },
                },
              },
            ],
          },
          {
            title: "Gifts & New Releases",
            items: [
              {
                columns: [
                  {
                    title: "Gifts & Inspiration",
                    items: [
                      {
                        title: "Best in Travel 2025",
                        url: "https://shop.lonelyplanet.com/products/lonely-planets-best-in-travel-2025?utm_source=lonelyplanet&utm_campaign=navigation&utm_content=gifts-bit",
                        tracking: {
                          event: "ProductClicked",
                          product: { brand: "Shop" },
                        },
                      },
                      {
                        title: "Outdoor Adventure",
                        url: "https://shop.lonelyplanet.com/collections/outdoor-travel-and-adventures?utm_source=lonelyplanet&utm_campaign=navigation&utm_content=gifts-outdoor",
                      },
                      {
                        title: "Food",
                        url: "https://shop.lonelyplanet.com/collections/food-drink?utm_source=lonelyplanet&utm_campaign=navigation&utm_content=gifts-food",
                      },
                      {
                        title: "Lonely Planet Kids",
                        url: "https://shop.lonelyplanet.com/collections/kids?utm_source=lonelyplanet&utm_campaign=navigation&utm_content=gifts-kids",
                      },
                      {
                        title: "Merchandise",
                        url: "https://shop.lonelyplanet.com/collections/lonely-planet-merchandise?utm_source=lonelyplanet&utm_campaign=navigation&utm_content=gifts-merchandise",
                      },
                      {
                        title: "View All Gifts & Inspiration",
                        url: "https://shop.lonelyplanet.com/collections/gifts-inspiration?utm_source=lonelyplanet&utm_campaign=navigation&utm_content=gifts-inspiration",
                      },
                    ],
                  },
                  {
                    title: "New Releases",
                    items: [
                      {
                        title: "Portugal",
                        url: "https://shop.lonelyplanet.com/products/portugal?utm_source=lonelyplanet&utm_campaign=navigation&utm_content=gifts-portugal",
                        tracking: {
                          event: "ProductClicked",
                          product: { brand: "Shop" },
                        },
                      },
                      {
                        title: "Rome",
                        url: "https://shop.lonelyplanet.com/products/rome?utm_source=lonelyplanet&utm_campaign=navigation&utm_content=gifts-rome",
                        tracking: {
                          event: "ProductClicked",
                          product: { brand: "Shop" },
                        },
                      },
                      {
                        title: "Spain",
                        url: "https://shop.lonelyplanet.com/products/spain?utm_source=lonelyplanet&utm_campaign=navigation&utm_content=gifts-spain",
                        tracking: {
                          event: "ProductClicked",
                          product: { brand: "Shop" },
                        },
                      },
                      {
                        title: "View All New Releases",
                        url: "https://shop.lonelyplanet.com/collections/new-releases?utm_source=lonelyplanet&utm_campaign=navigation&utm_content=gifts-newreleases",
                      },
                    ],
                  },
                ],
              },
            ],
          },
          {
            title: "Guide Types",
            items: [
              {
                title: "Classic Guides",
                description:
                  "For travelers seeking the most comprehensive insights. These guides provide in-depth insights for your trips, helping you explore destinations deeply for unforgettable experiences, whether popular or off the beaten path.",
                url: "https://shop.lonelyplanet.com/collections/classic-guides?utm_source=lonelyplanet&utm_campaign=navigation&utm_content=guidetypes-classic",
              },
              {
                title: "Experience Guides",
                description:
                  "For travelers looking to design a trip that feels unique. Experience guides offer travelers innovative ways to discover iconic destinations, featuring unique adventures and trip-building tools for personalized journeys.",
                url: "https://shop.lonelyplanet.com/collections/experience-guides?utm_source=lonelyplanet&utm_campaign=navigation&utm_content=guidetypes-experience",
              },
              {
                title: "Language Guides",
                description:
                  "For travelers looking to immerse themselves in local culture and language essentials. Language Guides help to let no barriers - language or culture - get in your way.",
                url: "https://shop.lonelyplanet.com/collections/language-guides-all?utm_source=lonelyplanet&utm_campaign=navigation&utm_content=guidetypes-language",
              },
              {
                title: "Epic Guides",
                description:
                  "From hikes to bike rides and surf breaks, discover the most epic adventures across the world to inspire your next trip. Epic Guides provide inspiration and first-person stories for a lifetime of unforgettable travel experiences.",
                url: "https://shop.lonelyplanet.com/collections/epic-guides?utm_source=lonelyplanet&utm_campaign=navigation&utm_content=guidetypes-epic",
              },
              {
                title: "Pocket Guides",
                description:
                  "For travelers on a short trip that want to make the most of their time exploring. Pocket Guides are compact guides for short trips that offer the best local experiences.",
                url: "https://shop.lonelyplanet.com/collections/pocket?utm_source=lonelyplanet&utm_campaign=navigation&utm_content=guidetypes-pocket",
              },
              {
                title: "Maps",
                description:
                  "Durable and waterproof, with a handy slipcase and an easy-fold format, Lonely Planet's country maps are designed to let you explore with ease.",
                url: "https://shop.lonelyplanet.com/collections/maps?utm_source=lonelyplanet&utm_campaign=navigation&utm_content=guidetypes-maps",
              },
            ],
          },
        ],
      },
    },
    {
      title: "Trips",
      url: "https://www.elsewhere.io/?utm_source=lonelyplanet&utm_medium=globalnav&utm_campaign=header",
      cta: {
        title: "view all trips",
        url: "https://www.elsewhere.io?utm_source=lonelyplanet&utm_medium=globalnav&utm_campaign=main-placement",
        tracking: {
          event: "ProductClicked",
          product: { brand: "Elsewhere" },
        },
      },
      featured: {
        title: "Custom trips, built for you",
        description:
          "Embark on your next adventure with Elsewhere by Lonely Planet.",
        image:
          "https://lonelyplanetstatic.imgix.net/marketing/2025/global_nav/nav_elsewhere.jpg",
        cta: {
          title: "find your next trip",
          url: "https://www.elsewhere.io?utm_source=lonelyplanet&utm_medium=globalnav&utm_campaign=main-placement",
        },
        tracking: {
          event: "ProductClicked",
          product: { brand: "Elsewhere" },
        },
      },
      submenu: {
        items: [
          {
            title: "Popular Trips",
            items: [
              {
                title: "Costa Rica",
                url: "https://www.elsewhere.io/costa-rica?utm_source=lonelyplanet&utm_medium=globalnav&utm_campaign=costa-rica",
                tracking: {
                  event: "ProductClicked",
                  product: { brand: "Elsewhere" },
                },
              },
              {
                title: "France",
                url: "https://www.elsewhere.io/france?utm_source=lonelyplanet&utm_medium=globalnav&utm_campaign=france",
                tracking: {
                  event: "ProductClicked",
                  product: { brand: "Elsewhere" },
                },
              },
              {
                title: "Iceland",
                url: "https://www.elsewhere.io/iceland?utm_source=lonelyplanet&utm_medium=globalnav&utm_campaign=iceland",
                tracking: {
                  event: "ProductClicked",
                  product: { brand: "Elsewhere" },
                },
              },
              {
                title: "Italy",
                url: "https://www.elsewhere.io/italy?utm_source=lonelyplanet&utm_medium=globalnav&utm_campaign=italy",
                tracking: {
                  event: "ProductClicked",
                  product: { brand: "Elsewhere" },
                },
              },
              {
                title: "Japan",
                url: "https://www.elsewhere.io/japan?utm_source=lonelyplanet&utm_medium=globalnav&utm_campaign=japan",
                tracking: {
                  event: "ProductClicked",
                  product: { brand: "Elsewhere" },
                },
              },
              {
                title: "Morocco",
                url: "https://www.elsewhere.io/morocco?utm_source=lonelyplanet&utm_medium=globalnav&utm_campaign=morocco",
                tracking: {
                  event: "ProductClicked",
                  product: { brand: "Elsewhere" },
                },
              },
              {
                title: "Portugal",
                url: "https://www.elsewhere.io/portugal?utm_source=lonelyplanet&utm_medium=globalnav&utm_campaign=portugal",
                tracking: {
                  event: "ProductClicked",
                  product: { brand: "Elsewhere" },
                },
              },
              {
                title: "Spain",
                url: "https://www.elsewhere.io/spain?utm_source=lonelyplanet&utm_medium=globalnav&utm_campaign=spain",
                tracking: {
                  event: "ProductClicked",
                  product: { brand: "Elsewhere" },
                },
              },
              {
                title: "Turkey",
                url: "https://www.elsewhere.io/turkey?utm_source=lonelyplanet&utm_medium=globalnav&utm_campaign=turkey",
                tracking: {
                  event: "ProductClicked",
                  product: { brand: "Elsewhere" },
                },
              },
              {
                title: "Vietnam",
                url: "https://www.elsewhere.io/vietnam?utm_source=lonelyplanet&utm_medium=globalnav&utm_campaign=vietnam",
                tracking: {
                  event: "ProductClicked",
                  product: { brand: "Elsewhere" },
                },
              },
              {
                title: "Book tours & activities",
                url: "https://www.getyourguide.com/?partner_id=MH9NGR8&cmp=homepage_navigation&deeplink_id=cc65224c-8be2-598a-9a86-0b28ce4c3c48&page_id=b9971ae8-0937-5d9f-97f4-58ffcff19023",
                tracking: {
                  event: "ProductClicked",
                  actionOutcome: "EXTERNALLINK",
                  product: { brand: "GYG" },
                },
              },
            ],
          },
        ],
      },
      tracking: {
        event: "ProductClicked",
        product: { brand: "Elsewhere" },
      },
    },
    {
      title: "Stories",
      url: "https://www.lonelyplanet.com/articles",
      cta: {
        title: "view all stories",
        url: "https://www.lonelyplanet.com/articles",
      },
      featured: {
        title: "The Ultimate Guide to Summer",
        description:
          "Dive into our guides, stories, and more to find Lonely Planet's favorite (and sometimes unexpected) summer destinations.",
        image:
          "https://lonelyplanetstatic.imgix.net/marketing/2025/global_nav/nav_summer_guide_2x.jpg",
        cta: {
          title: "Explore our Summer Guide",
          url: "https://www.lonelyplanet.com/campaigns/ultimate-guide-to-summer",
        },
      },
      submenu: {
        items: [
          {
            title: "Summer Guide",
            items: [
              {
                title: "The Ultimate Guide to Summer",
                url: "https://www.lonelyplanet.com/campaigns/ultimate-guide-to-summer",
                cta: {
                  title: "Explore our Summer Guide",
                  url: "https://www.lonelyplanet.com/campaigns/ultimate-guide-to-summer",
                },
                description:
                  "Welcome to Lonely Planet's Ultimate Guide to Summer! Starting with Europe, we'll be adding all sorts of resources to inspire your next summer travel adventure.\n\nDive into our guides, stories, and more to find Lonely Planet's favorite (and sometimes unexpected) summer destinations.",
                image:
                  "https://lonelyplanetstatic.imgix.net/marketing/2025/global_nav/nav_summer_guide_2x.jpg",
              },
            ],
          },
          {
            title: "Best in Travel",
            items: [
              {
                title: "Best in Travel",
                url: "https://www.lonelyplanet.com/best-in-travel",
                cta: {
                  title: "Explore Best in Travel 2025",
                  url: "https://www.lonelyplanet.com/best-in-travel",
                },
                description:
                  "Lonely Planet's annual Best in Travel list ranks the year's 30 hottest (and coolest) destinations, including popular favorites and under-the-radar spots chosen by our global team of expert contributors.",
                image:
                  "https://lonelyplanetstatic.imgix.net/marketing/2025/global_nav/nav_bit.jpg",
              },
            ],
          },
          {
            title: "Newsletter",
            items: [
              {
                title: "Subscribe to Lonely Planet's newsletter",
                url: "https://www.lonelyplanet.com/newsletter",
                cta: {
                  title: "Learn more about our newsletters",
                  url: "https://www.lonelyplanet.com/newsletter",
                },
                description:
                  "Join our community to get discounts, travel inspiration and trip ideas – just in time for summer!",
                image:
                  "https://lonelyplanetstatic.imgix.net/marketing/2025/global_nav/nav_newsletter.jpg",
              },
            ],
          },
          {
            title: "By Topic",
            items: [
              {
                title: "Adventure Travel",
                url: "https://www.lonelyplanet.com/articles/category/adventure-travel",
              },
              {
                title: "Art and Culture",
                url: "https://www.lonelyplanet.com/articles/category/art-and-culture",
              },
              {
                title: "Beaches, Coasts and Islands",
                url: "https://www.lonelyplanet.com/articles/category/beaches",
              },
              {
                title: "Family Holidays",
                url: "https://www.lonelyplanet.com/articles/category/family-travel",
              },
              {
                title: "Festivals",
                url: "https://www.lonelyplanet.com/articles/category/festivals-and-events",
              },
              {
                title: "Food and Drink",
                url: "https://www.lonelyplanet.com/articles/category/food-and-drink",
              },
              {
                title: "Honeymoon and Romance",
                url: "https://www.lonelyplanet.com/articles/category/romance",
              },
              {
                title: "Road Trips",
                url: "https://www.lonelyplanet.com/articles/category/road-trips",
              },
              {
                title: "Sustainable Travel",
                url: "https://www.lonelyplanet.com/articles/category/sustainable-travel",
              },
              {
                title: "Travel on a Budget",
                url: "https://www.lonelyplanet.com/articles/category/budget-travel",
              },
              {
                title: "Wildlife and Nature",
                url: "https://www.lonelyplanet.com/articles/category/wildlife-and-nature",
              },
            ],
          },
        ],
      },
    },
  ],
};
